import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import ExpansionPanel from '@/views/components/ExpansionPanel.vue';
import AlertCard from '@/views/components/AlertCard.vue';
import { mdiFilterVariant } from '@mdi/js';
import FiltroOrdenacao from '@/views/components/FiltroOrdenacao.vue';
import CardResultado from './CardResultado.vue';
import { ConsultaBoletinsStore } from '../../store/ConsultaBoletinsStore';
import { storeToRefs } from 'pinia';
import { mdiEye } from '@mdi/js';
import {
  contemNaLista,
  isTodosSelecionados,
  selecionarTodos,
  toggleSelecionado,
} from '@/utils/ListUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResultadoConsulta',
  setup(__props) {

const store = ConsultaBoletinsStore();

const {
  boletins,
  boletinsSelecionados,
  pageSubfiltros,
  totalElementos,
  pagina,
  filtroBoletins,
  totalHits,
  temBoletinsTiposDiferentes,
  tipoBoletimSelecionadoParaImpressao,
} = storeToRefs(store);

const { download, consultaBoletins } = store;

const resultadoConsulta = ref();

const ordenacao = [
  { text: 'Ano de publicação decrescente', value: 'nuAno DESC' },
  { text: 'Ano de publicação crescente', value: 'nuAno asc' },
  { text: 'Data de julgamento decrescente', value: 'dtjulgamento DESC' },
  { text: 'Data de julgamento crescente', value: 'dtjulgamento ASC' },
  { text: 'Relevância', value: 'derelevancia' },
];

const ordenacaoSelecionada = ref({
  text: 'Ano de publicação decrescente',
  value: 'nuAno DESC',
});

const consulta = () => {
  pagina.value = 1;
  consultaBoletins();
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const atualizarOrdenacao = (ordenacao: any) => {
  ordenacaoSelecionada.value = ordenacao;
  filtroBoletins.value.ordenacao = ordenacao.value;
  consultaBoletins();
};

const atualizarPaginacao = async () => {
  resultadoConsulta.value.scrollIntoView({ behavior: 'smooth' });
  await consultaBoletins();
};

const limparFiltrosResultado = () => {
  pageSubfiltros.value?.forEach((filtro) =>
    filtro?.valoresSubFiltroResponseDTO?.forEach(
      (subFiltro) => (subFiltro.checked = false)
    )
  );
};

return { __sfc: true,store, boletins, boletinsSelecionados, pageSubfiltros, totalElementos, pagina, filtroBoletins, totalHits, temBoletinsTiposDiferentes, tipoBoletimSelecionadoParaImpressao, download, consultaBoletins, resultadoConsulta, ordenacao, ordenacaoSelecionada, consulta, atualizarOrdenacao, atualizarPaginacao, limparFiltrosResultado, ExpansionPanel, AlertCard, mdiFilterVariant, FiltroOrdenacao, CardResultado, mdiEye, contemNaLista, isTodosSelecionados, selecionarTodos, toggleSelecionado }
}

})